export const resetPassword = (resetPasswordUrl, forgotPasswordReturnUrl) => {
  console.log(`resetPassword(${resetPasswordUrl}, ${forgotPasswordReturnUrl})`);
  const config = window.EIsAuthConfig;
  var encodedCallbackURL = encodeURIComponent(forgotPasswordReturnUrl || config.callbackURL);
  console.log(`encodedCallbackURL: ${encodedCallbackURL}`);
  var url =
    "https://" +
    resetPasswordUrl +
    "/user/reset-password" +
    "?returnUrl=" +
    encodedCallbackURL +
    "&ui_locales=EN";
  window.location.href = url;
};
